; (function (window, document, $) {
    'use strict';

    var ESC_KEY_KODE = 27;
    var $document = $(document);

    var OPTIONS = {
        eventNamespace: '.quick-search',
        eventName: 'click',
        stateClassName: 'has-quick-search-opened',
        otherClassNames: ['has-nav-opened'],
        componentSelector: '[data-ui-component="quick-search"]',
        componentQuerySelector: '[data-ui-component="quick-search-query"]'
    }

    var quickSearch = {
        init: function () {
            this.$html = $('html');
            this.$buttons = $('[data-ui-component="quick-search-button"]');
            this.$menu = $('[data-ui-component="site-nav-item"]');
            this.component = {
                component: $(OPTIONS.componentSelector),
                queryComponent: $(OPTIONS.componentSelector).find(OPTIONS.componentQuerySelector)
            }

            this.initEvents();
        },
        initEvents: function () {
            this.$buttons.on(OPTIONS.eventName + OPTIONS.eventNamespace, this.toggle.bind(this));
        },
        destroyEvents: function () {
            this.$buttons.off(OPTIONS.eventNamespace);
        },
        toggle: function () {
            if (this.$html.hasClass("has-quick-search-opened--default")) {
                this.setFocus();
                return;
            }

            this.$html.toggleClass(OPTIONS.stateClassName);

            if (this.$html.hasClass(OPTIONS.stateClassName)) {
                OPTIONS.otherClassNames.forEach((className) => {
                    this.$html.removeClass(className);
                });
                $(".c-site-nav").find(".is-selected").removeClass("is-selected");
            }

            this.setFocus();
        },
        close: function () {
            this.$html.removeClass(OPTIONS.stateClassName);
        },
        isOpen: function () {
            return this.$html.hasClass(OPTIONS.stateClassName);
        },
        setFocus: function () {
            if (this.component.queryComponent.length === 0) {
                return;
            }

            if (this.isOpen()) {
                setTimeout(function () { this.component.queryComponent.get(0).focus(); }.bind(this), 100);
            }
        }
    };

    quickSearch.init();
})(window, document, jQuery);